import {RGBRecord} from '../../@types/colors';

export default function isRgbRecord(item: any): item is RGBRecord {
    return item && typeof item === 'object' && 'R' in item && 'G' in item && 'B' in item;
}
